export const NavbarItems = [
  {
    title: "Home",
    url: "home",
    className: "nav-links",
  },
  {
    title: "About",
    url: "about",
    className: "nav-links",
  },
  {
    title: "Services",
    url: "services",
    className: "nav-links",
  },
  {
    title: "Products", 
    url: "products",
    className: "nav-links",
  },
  {
    title: "Contact Us",
    url: "contact-us",
    className: "nav-links-mobile",
  },
];
